import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import PublicNavbar from './PublicNavbar';
import PublicFooter from './PublicFooter';
import LoadingSpinner from '../Shared/LoadingSpinner';

const PublicLayout: React.FC = () => {
    return (
        // The `dark` class here permanently scopes all public pages to dark mode.
        // Tailwind's dark: utilities match any `.dark` ancestor — it does NOT need
        // to be on <html>. This means ThemeContext (which controls <html>) has zero
        // effect on the public site, and no useEffect race condition can occur.
        <div className="dark min-h-screen bg-gray-950 font-sans text-gray-100 flex flex-col">
            <PublicNavbar />
            <main className="flex-grow flex flex-col">
                <Suspense fallback={<LoadingSpinner />}>
                    <Outlet />
                </Suspense>
            </main>
            <PublicFooter />
        </div>
    );
};

export default PublicLayout;
